export enum QuickStatsAggregation {
    Actual = 'Actual',
    RollingAverage = 'RollingAverage',
    ExpandingAverage = 'ExpandingAverage'
}